/** @param {import('markdown-it')} md */
module.exports = function tabSwitchText(md) {
  md.block.ruler.before('paragraph', 'switch_content', function replace(state, startLine, endLine, silent) {
    if (silent) {
      return false;
    }

    const expectOpenerRegExpStartString = '[popup-content';
    const expectOpenerRegExp = new RegExp(`^\\${expectOpenerRegExpStartString}__([^\\s]+)\\]`);

    const start = state.bMarks[startLine] + state.tShift[startLine];
    if (state.src.charAt(start) !== expectOpenerRegExpStartString[0]) {
      return false;
    }

    if (state.src.substr(start, expectOpenerRegExpStartString.length) !== expectOpenerRegExpStartString) {
      return false;
    }

    const result = expectOpenerRegExp.exec(state.src.substr(start));
    if (!result || result.length !== 2) {
      return false;
    }

    const opener = result[0];
    const id = result[1];

    const expectCloser = `${opener[0]}/${opener.substring(1)}`;

    let content = '';
    let closerLine;
    let closeFlag = false;

    for (closerLine = startLine + 1; closerLine <= endLine; closerLine++) {
      const closerStart = state.bMarks[closerLine] + state.tShift[closerLine];
      if (state.src.substr(closerStart, expectCloser.length) === expectCloser) {
        closeFlag = true;
        break;
      }

      content += state.getLines(closerLine, closerLine + 1, state.blkIndent, false) + '\n';
    }

    if (!closeFlag) {
      return false;
    }

    const oldParent = state.parentType;
    let token;

    state.parentType = 'popup_content_wrapper';
    token = state.push('popup_content_wrapper_open', 'div', 1);
    token.attrs = [['class', 'popup-content-wrapper'], ['id', `popup-content__${id}`]];
    token.block = true;

    state.parentType = 'popup_content_background';
    token = state.push('popup_content_background_open', 'div', 1);
    token.attrs = [['class', 'popup-content-background']];
    token.block = true;
    token = state.push('popup_content_close', 'div', -1);
    token.block = true;

    state.parentType = 'popup_content_closer_open';
    token = state.push('popup_content_open', 'div', 1);
    token.attrs = [['class', 'popup-content-closer']];
    token.block = true;

    state.parentType = 'popup_content_closer_img';
    token = state.push('popup_content_closer_img', 'img', 1);
    token.attrs = [['src', '/img/icon_close_white.svg'], ['alt', 'close']];

    token = state.push('popup_content_closer_close', 'div', -1);
    token.block = true;

    state.parentType = 'popup_content';
    token = state.push('popup_content_open', 'div', 1);
    token.attrs = [['class', 'popup-content']];
    token.block = true;

    state.parentType = 'popup_content_body';
    token = state.push('popup_content_body_open', 'div', 1);
    token.markup = opener;
    token.attrs = [['class', 'popup-content__body']];
    token.block = true;

    const contentTokens = [];
    state.md.block.parse(content, state.md, state.env, contentTokens);
    contentTokens.forEach((t) => {
      state.tokens.push(t);
    });

    token = state.push('popup_content_body_close', 'div', -1);
    token.markup = expectCloser;
    token.block = true;

    token = state.push('popup_content_lose', 'div', -1);
    token.markup = expectCloser;
    token.block = true;

    token = state.push('popup_content_wrapper_close', 'div', -1);
    token.block = true;

    state.parentType = oldParent;
    state.line = closerLine + 1;


    return true;
  });
};
